/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import React from 'react';
import { Heading, Box, Grid, Text } from '@theme-ui/components';
import {
	ItemListContainer,
	ActLink,
	ItemGrid,
	ItemGridBox,
	PillarLink,
	StateLink,
	StateHolidayListLink,
	StateProfTaxLink,
	StateShopsLink,
	StateLwfLink,
	StateCowLink,
	StateIrcLink,
	StateCossLink,
	StateOshwcLink,
} from './Utils';
import { typography, colors } from '../../styles/theme';
import { CustomLink } from '../atoms';

export const PillarList = ({ pillars }) => (
	<ItemListContainer>
		<Heading
			my={1}
			variant='wikiHeading2'
		>
			Resources
		</Heading>
		<Box
			sx={{ mt: 3, border: '0px solid red' }}
			as='ul'
		>
			{pillars.length > 0 ? (
				pillars.map((pillar) => (
					<li>
						<PillarLink item={pillar} />
					</li>
				))
			) : (
				<Text>Sorry, no acts are listed as of now.</Text>
			)}
		</Box>
	</ItemListContainer>
);

export const ActsList = ({
	nodes,
	stopWord,
	shortName = false,
	suppressTitle = false,
	heading = 'Related Acts',
}) => (
	<ItemListContainer>
		{!suppressTitle ? (
			<Heading as='h6' sx={{ ...typography.h6 }}>
				{heading}
			</Heading>
		) : null}
		<Box sx={{ p: '0 !important', mt: '1rem', border: `1px solid ${colors.neutral200}`, borderRadius: '20px' }} as='ul'>
			{nodes ? (
				nodes.map((act, index) => {
					let name = shortName && act.shortName ? act.shortName : act.name;
					if (!!stopWord) {
						name = name.replace(stopWord, '');
					}
					return (
						<li sx={{ m: '0 !important', p: '1rem', borderBottom: index === (nodes.length - 1) ? '' : `1px solid ${colors.neutral200}` }} key={`st-${act.slug}-${index}`}>
							<CustomLink url={`/wiki/acts/${act.slug}/`}>{name}</CustomLink>
						</li>
					);
				})
			) : (
				<Text>Sorry, no acts are listed as of now.</Text>
			)}
		</Box>
	</ItemListContainer>
);

export const ActsStateList = ({ acts }) => (
	<ItemGrid>
		{acts.map(({ slug, state: { name } }) => (
			<ItemGridBox key={`st-asl-${slug}`}>
				<ActLink item={{ name, slug }} />
			</ItemGridBox>
		))}
	</ItemGrid>
);

/**
 * This component is called Switchable because the page to which each state links to
 * can be switched.
 *
 * @param {*} param0
 */
export const SwitchableStateList = ({
	nodes,
	suppressTitle = false,
	heading = 'States',
	linkType = 'state',
	holidayYear = '2021',
	showNavArrow = false,
}) => {
	
	return (
		<Box>
			{!suppressTitle ? (
				<Heading
					my={1}
					sx={{ ...typography.h2 }}
				>
					{heading}
				</Heading>
			) : null}
			<Grid
				gap='1.5rem'
				columns={[1, 1, 2, 2]}
				width={272}
				sx={{
					p: '0px !important',
					mt: 0,
					border: '0px solid red',
					maxWidth: linkType === 'holiday' ? null : '35.5rem',
				}}
				as='ul'
			>
				{nodes ? (
					nodes.map((state) => {
						const item = { slug: state.slug, name: state.name };
						return (
							<Box
								key={`st-${state.slug}`}
								as='li'
								sx={{ listStyle: 'none', a: { textDecoration: 'none' } }}
							>
								{linkType === 'state' && <StateLink item={item} />}
								{linkType === 'holiday' && (
									<StateHolidayListLink
										item={item}
										holidayYear={holidayYear}
									/>
								)}
								{linkType === 'proftax' && <StateProfTaxLink item={item} />}
								{linkType === 'shops' && <StateShopsLink item={item} />}
								{linkType === 'lwf' && <StateLwfLink item={item} />}
								{linkType === 'cow' && <StateCowLink item={item} />}
								{linkType === 'irc' && <StateIrcLink item={item} />}
								{linkType === 'coss' && <StateCossLink item={item} />}
								{linkType === 'oshwc' && <StateOshwcLink item={item} />}
							</Box>
						);
					})
				) : (
					<Text>Sorry, no states are listed as of now.</Text>
				)}
			</Grid>
		</Box>
	);
};
